export function accountHasRole(account, role) {
  return account.roles && account.roles.includes(role);
}
